<script>
import gql from 'graphql-tag'
import BaseLayout from '@/components/shared/layout/BaseLayout'
import platformDetect from '@/mixins/platformDetect'
import axios from 'axios'
import VueScrollTo from 'vue-scrollto'
export default {
  name: 'Credits',
  data () {
    return {
      container: null,
      link: null,
      valvid: '',
      thumbnail: '',
      open: false,
      resumeScroll: false,
    }
  },
  mixins: [
    platformDetect,
    // getUsagerStatistiques,
  ],
  mounted: function () {
    setTimeout(function () {
      VueScrollTo.scrollTo('#findescredits', 50000, { container: '#blocdecontenu', easing: 'linear' })
    }, 2000)
  },
  apollo: {
    container: {
      /*eslint-disable*/
      query: gql `query container($id: String!){
        container(id: $id){
          id categorie_list description titre medias{
            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}
          }
        }
      }`,
      variables () {
        return { id: 'faea436d-62b2-46a1-82e8-e8ab3409848d'}
      },
      fetchPolicy: 'cache-first',
      update: data => data.container,
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      },
    },
  },
  components: {
    BaseLayout,
  },
  methods: {
    /*eslint-disable*/
    scrollToTop () {
      VueScrollTo.scrollTo('#findescredits', 5, { container: '#blocdecontenu', easing: 'linear', onCancel: function() { this.resumeScroll = true } })
    },
    resume () {
      VueScrollTo.scrollTo('#findescredits', 5000, { container: '#blocdecontenu', easing: 'linear', onCancel: function() { this.resumeScroll = true } })
    },
    /*eslint-enable*/
    getVid: function (url) {
      if (url.includes('youtube')) {
        var link = url.replace(/(<([^>]+)>)/ig, '')
          /* eslint-disable */
        var re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([\w\-]{10,12})(?:&feature)?(?:[\w\-]{0})?/g
        var iframe = 'https://www.youtube.com/embed/$1'
          /* eslint-enable */
        link = iframe.replace('$1', link.split(re)[1])
        // console.log(link)
        return link
      } else {
        axios.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (response) {
          // console.log(response.data)
          var temp = response.data
          // console.log(temp)
          // console.log('test')
          // console.log(temp)
          // console.log(temp.html)
          this.valvid = temp.html
          return temp.html
        })
      }
    },
    async getHTML (url) {
      // console.log('test')
      var h = Math.round(document.documentElement.clientHeight * 0.5)
      var w = Math.round(document.documentElement.clientWidth * 0.8)
      try {
        /*eslint-disable*/
        var temp = await axios.get('https://vimeo.com/api/oembed.json?url=' + url + '&width='+ w +'&height=' + h )
        /*eslint-enable*/
      } finally {
        // console.log(temp.data.thumbnail_url_with_play_button)
        // console.log(temp.data.html)
        this.valvid = temp.data.html
        this.thumbnail = temp.data.thumbnail_url_with_play_button
      }
    },
    isVimeo: function (url) {
      if (url.includes('vimeo')) {
        this.getHTML(url)
        return true
      } else {
        return false
      }
    },
  },
}
</script>
<template lang="pug">
base-layout
  div.backgroundtexture
  //- div.backgroundimg
  div.credits(v-if='container')
    div.bloctitre {{container.titre}}
      hr.mv1
      span.f4 Dreaming of a Jewish Christmas
    div.soustitre(v-for="med in container.medias")
      div(v-if="med.image")
        img(:src="med.image.thumbnail", width="90%" height="90%")
        //- img(v-if="med.image", :src="med.image.url")
        //- p {{med.image.description}}
    div.blocdescriptioncredits
      div.blocdecontenucredits(style='height: 85%; overflow: scroll;', id='blocdecontenu', v-html="container.description")
        q-fixed-position(corner='bottom-right', :offset="[18, 18]")
          q-btn.fa.fa-arrow-up(@click='scrollToTop()', class="animate-pop", round, v-back-to-top.animate='{offset: 50, duration: 200}', color='negative', style='margin: 0 48% 100px 0')
      div(id='findescredits')
      //- q-btn.boutoncredits(v-bind:class="{ active: resumeScroll }", @click='resume') Continue credits

      //  div.soustitre(v-for="med in container.medias")
          div(v-if="med.video")
            div(v-if="isVimeo(med.video.link)")
              div(v-html='valvid')
            div(v-else)
              q-video(:src='getVid(med.video.link)', style="height: 300px;")
              p {{med.video.titre}}
          //- div.soustitre(v-html='med.video.description')

</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.credits{
  -moz-animation: fadeInUp 2;
  -webkit-animation: fadeInUp 2s;
  animation: fadeInUp 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.backgroundimg{
  -moz-animation: fadeInUp 2;
  -webkit-animation: fadeInUp 2s;
  animation: fadeInUp 2s;
  animation-fill-mode: both;
  -moz-animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
/*mobile*/
::-webkit-scrollbar {
    width: 0px;  /* remove scrollbar space */
    background: transparent;  /* optional: just make scrollbar invisible */
}
/* optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    background: transparent!important;
}
.layout-page-container{
  height: 100% !important;
}
.active{
  display: block;
}
.boutoncredits{
  border-radius: 10px!important;
  border: solid white 2px!important;
  color:white!important;
  font-size: 16px!important;
  font-family: Abril Fatface;
  margin:20px 0 10px 0;
  width:200px;
}
@media only screen and (min-width: 320px){
  .backgroundtexture{
  background-image: url("~@/assets/JWWC-SET-6_dark_light.jpg");
  background-size: cover;
  height: 100%;
  min-height:100vh;
  width:100vw;
  z-index:-10;
  position:fixed;
  }
  .credits {
  padding: 50px 35px 40px 35px;
    & .bloctitre {
      /*width: ;*/
      font-family: Abril Fatface;
      font-size: 35px;
      margin: 0 auto 0;
      width:90%;
      /*background-color: red;*/
      color:white;
      padding: 20px 20px 20px 20px;
      border-style: double;
      border-width: 10px;
      border-color:White;
    }
    & .blocdescriptioncredits{
      height:calc(100vh - 280px);
      overflow-y:scroll;
      margin-top:20px;
      & .titreprincipalcredits{
        color: white;
        font-family: Abril Fatface;
        font-size: 30px;
        /*margin-top: 40px;*/
        margin-bottom:10px;

      }
      & h2.titrecredits{
        color: white;
        font-family: Abril Fatface;
        font-size: 30px;
        margin-top: 40px;
        margin-bottom:30px;
      }
      & h3.soustitrecredits{
        color: white;
        font-family: Barlow Condensed;
        font-size: 26px;
        margin-top: 20px;
        margin-bottom:10px;
      }
      & p{
        color:white;
        margin-bottom:10px;
        text-align: center;
      }
    }
  }
}
@media only screen and (min-width: 320px) and (max-width: 767px) and (orientation:landscape) {
  .credits {
  padding: 50px 35px 40px 35px;
    & .bloctitre {
      /*width: ;*/
      font-family: Abril Fatface;
      font-size: 35px;
      margin: 0 auto 0;
      width:80%;
      /*background-color: red;*/
      color:white;
      padding: 20px 20px 20px 20px;
      border-style: double;
      border-width: 10px;
      border-color:White;
    }
  }
  .blocdescriptioncredits{
    height:100vh!important;
    overflow-y:scroll;
    overflow-x:hidden;
  }
}
@media only screen (min-width: 767px) {
}
@media only screen and (min-width: 961px){
  .credits{
    & .bloctitre {
      font-family: Abril Fatface;
      font-size: 35px;
      width:500px;
      margin: 20px auto 20px;
      /*background-color: red;*/
      padding: 30px 30px 30px 30px;
      border-style: double;
      border-width: 10px;
      color:white;
      border-color:white;
    }
    & .blocdescriptioncredits{
      width:500px;
      height: calc(100vh - 300px);
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Credits.vue?3e033ceb